// @flow
import * as React from 'react'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import './styles.scss'

function ArticleLink({
  publisherDomain,
  articleId,
  title,
  lead
}: {
  publisherDomain: string,
  articleId: string,
  title: string,
  lead: string
}) {
  return (
    <a
      href={`https://www.${publisherDomain}/${articleId}`}
      target='_parent'
      className='item'
    >
      <i className='external icon top aligned' />
      <div className='content'>
        <div className='header'>{title}</div>
        {lead}
      </div>
    </a>
  )
}

export function ArticleList() {
  const publisherDomain = parseHostname().publicationDomain

  return (
    <aside
      className='ui segment article-list'
      style={{ backgroundColor: '#f9d095' }}
    >
      <h4 className='ui infographic tiny header'>
        Weitere Storys zum Hotelrating:
      </h4>
      <div className='ui icon very relaxed infographic list'>
        <ArticleLink
          publisherDomain={publisherDomain}
          articleId={'27754656'}
          title={'«Allein hätte Andermatt es nie geschafft»'}
          lead={
            'Ski-Ikone Bernhard Russi über das Wunder von Andermatt, nervige Kritiker und neue Projekte.'
          }
        />
        <ArticleLink
          publisherDomain={publisherDomain}
          articleId={'21585205'}
          title={'Der Lenkerhof kennt keinen Stillstand'}
          lead={
            'Im laut Eigenwerbung «jugendlichsten Luxushotel der Schweiz» geht der Chef mit guter Laune voran – und plant Grosses.'
          }
        />
        <ArticleLink
          publisherDomain={publisherDomain}
          articleId={'17124042'}
          title={'Ein Märchen auf der Heide'}
          lead={
            'Der Milliardär Alfred Gantner und seine Frau Cornelia schufen mit dem Guarda Val eines der genialsten Hotels der Alpen.'
          }
        />
      </div>
    </aside>
  )
}
